import { Modal } from "react-bootstrap";
import { Button } from "../button";

import { ViewDigitalSignatureModalProps } from "./RequestDigitalSignatureModal.types";
import { FormPreview } from "../form-preview";
import { DigitalSignatureRequestStatuses } from "../../entities/IDigitalSignature";
import { Icon } from "../../modules/icon";

export const ViewDigitalSignatureModal = ({
  isVisible,
  onDismiss,
  fields,
  onDelete,
  onResend,
}: ViewDigitalSignatureModalProps) => {
  const showDeleteOption = !!(
    fields.find((item) => item.label === "Status")?.value !==
    DigitalSignatureRequestStatuses.SIGNED[0].toUpperCase() +
      DigitalSignatureRequestStatuses.SIGNED.slice(1)
  );
  const showResendConfirmation = false; // make it false for now
  /* !!(
    fields.find((item) => item.label === "Status")?.value ===
    DigitalSignatureRequestStatuses.PENDING[0].toUpperCase() +
      DigitalSignatureRequestStatuses.PENDING.slice(1)
  ); */
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Digital Signature Info
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <FormPreview fields={fields} />
        {showDeleteOption && (
          <Button onClick={onDelete} className="btn btn-danger w-100 mt-4">
            Delete Digital Signature
          </Button>
        )}
        {showResendConfirmation && (
          <Button
            className="btn btn-primary w-100 btn-secondary-washed"
            onClick={(event) => {
              event?.stopPropagation();
              onResend();
            }}
          >
            <Icon type={"fa-solid fa-arrows-rotate"} />
            &nbsp;Resend Confirmation
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};
